var formType: any;
var autoLogin: any;

const form: any = document.querySelector('form.forminator-custom-form');

if (form) {
    document.querySelector('form.forminator-custom-form').addEventListener('submit', function (e) {
        const formData = new FormData(form);
        autoLogin = formData.get('auto_login');

        if (formData.get('account_type_option') === 'mixed') {
            formType = formData.get('account_type-1'); // Adjust field name if necessary
        } else {
            formType = formData.get('account_type_option');
        }
        console.log("Registering as: " + formType);
    });

    jQuery(document).on('forminator:form:submit:success', function (event: any, form_id: any) { 
        if (formType == 'individual') {
            window.location.href = window.location.origin + '/my-account';
        } else if (formType == 'organization' && autoLogin == '1') {
            window.location.href = window.location.origin + '/organization/';
        }
    });
}